import api from '@/api/notificationTemplate'

const state = {

}

const actions = {
  getTemplateById (context, params) {
    return api.getTemplateById(params)
  },
  deleteTemplate (context, params) {
    return api.deleteTemplate(params)
  },
  updateTemplate (context, params) {
    return api.updateTemplate(params)
  },
  createTemplate (context, params) {
    return api.createTemplate(params)
  },
  searchTemplate (context, params) {
    return api.searchTemplate(params)
  },
  createLayoutTemplate (context, params) {
    return api.createLayoutTemplate(params)
  },
  getLayoutTemplateById (context, params) {
    return api.getLayoutTemplateById(params)
  },
  deleteLayoutTemplate (context, params) {
    return api.deleteLayoutTemplate(params)
  },
  updateLayoutTemplate (context, params) {
    return api.updateLayoutTemplate(params)
  },
  searchLayoutTemplate (context, params) {
    return api.searchLayoutTemplate(params)
  },
  getSystemTemplateById (context, params) {
    return api.getSystemTemplateById(params)
  },
  updateSystemTemplate (context, params) {
    return api.updateSystemTemplate(params)
  },
  searchSystemTemplate (context, params) {
    return api.searchSystemTemplate(params)
  },
  createSystemLayoutTemplate (context, params) {
    return api.createSystemLayoutTemplate(params)
  },
  getSystemLayoutTemplateById (context, params) {
    return api.getSystemLayoutTemplateById(params)
  },
  deleteSystemLayoutTemplate (context, params) {
    return api.deleteSystemLayoutTemplate(params)
  },
  updateSystemLayoutTemplate (context, params) {
    return api.updateSystemLayoutTemplate(params)
  },
  searchSystemLayoutTemplate (context, params) {
    return api.searchSystemLayoutTemplate(params)
  },
  searchTemplateField (context, params) {
    return api.searchTemplateField(params)
  },
  sendEmail (context, params) {
    return api.sendEmail(params)
  },
  getCompanyEmailTemplateByType (context, params) {
    return api.getCompanyEmailTemplateByType(params)
  },
  getCompanyInterviewEmailTemplate (context, params) {
    return api.getCompanyInterviewEmailTemplate(params)
  },
  getCompanyInviteHmRateEmailTemplate (context, params) {
    return api.getCompanyInviteHmRateEmailTemplate(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
